export namespace PersonnelManageAPI {
  // 用户角色
  export enum ROLE {
    ADMIN = 'Admin',
    USER = 'User',
    MANAGER = 'manager',
    CUSTOMER = 'customer',
    TEAM_USER = 'team_user',
  }
  // 角色映射
  export const ROLE_LIST = {
    [ROLE.ADMIN]: 'administrators',
    [ROLE.USER]: 'ordinary_user',
    [ROLE.MANAGER]: 'manager',
    [ROLE.CUSTOMER]: 'customer',
    [ROLE.TEAM_USER]: 'team_user',
  } as const;

  export namespace Request {
    export interface PersonnelInfoParams {
      contactName?: string;
      email?: string;
      isActive?: number;
    }
    export interface AddParams {
      groupId?: number;
      groupIds?: number[];
      teamRole?: string;
      contactName: string;
      email: string;
      contactNumber: string;
    }
    export interface EditParams {
      userId: number;
      isActive: number;
      userGroups?: number[];
      teamRole?: string;
      contactName: string;
      email: string;
      contactNumber: string;
    }
  }
  export namespace Response {
    export interface Info {
      contactName: string;
      contactNumber: string;
      email: string;
      isActive: number;
      isParent: number;
      /**  TODO：用户组，目前单角色，后续扩展多角色 */
      userGroups?: number[];
      teamRole?: string;
      teamName?: string;
      createTime?: string;
      userId: number;
    }
    export interface GroupInfo {
      id: number;
      name: keyof typeof ROLE_LIST;
    }
  }
}
